// Import the functions you need from the SDKs you need
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDfCcCSIUfxAz5H7M0pju7cT6N-uo4pj60",
  authDomain: "balloon-dec.firebaseapp.com",
  projectId: "balloon-dec",
  storageBucket: "balloon-dec.firebasestorage.app",
  messagingSenderId: "495067611052",
  appId: "1:495067611052:web:b353f7c37648b6f7df4409",
  measurementId: "G-J68F59HE1X"
};


const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Initialize analytics only in browser environment
let analytics = null;
if (typeof window !== 'undefined') {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    console.log('Analytics initialization skipped:', error.message);
  }
}
export { analytics };